<template>
  <v-card style="display: inline-block;vertical-align: middle" class="mr-auto ml-auto formForgetPassword">
    <v-card-title class="pa-5 pb-3">
      <p>{{ languageData.cardHeader }}</p>
    </v-card-title>
    <v-card-text>
      <v-form
        ref="formF"
        v-model="validF"
        lazy-validation
        v-if="languageData.labels">
        <v-row>
          <v-col cols="12">
            <v-text-field
              :label="languageData.labels.email"
              v-model="data.email"
              :rules="rules.email">
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn
              :loading="forgetIsFetching"
              @click="forgetPasswordUser"
              color="primary"
              class="btnSubmitForgetPasswordForm">
              {{ languageData.btnSubmit }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <ModalInfo :headModal="modalData.headInfoForgetPassword" :typeInfo="modalData.typeInfoForgetPassword" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isUserForgetPassword" :text-modal="modalData.textInfoForgetPassword"></ModalInfo>
  </v-card>
</template>

<script type="text/javascript">
  import {mapActions, mapState} from "vuex";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import eventBus from "../../../../event-bus/eventBus";
  import handleFormError from "../../../../helpers/handleFormError";

  export default {
    created() {
      eventBus.$on("forgetPasswordFailure", (errorsData) => {
        this.rules = handleFormError(errorsData);
        this.$refs.formF.validate();
      });
    },
    name: "ForgetPasswordForm",
    components: {ModalInfo},
    data() {
      return {
        validF: false,
        data: {},
        rules: {}
      }
    },
    computed: {
      ...mapState('forgetPassword', {
        forgetIsFetching: state => state.forgetIsFetching,
        modalData: state => state.modalData,
        isUserForgetPassword: state => state.isUserForgetPassword
      }),
    },
    methods: {
      ...mapActions('forgetPassword', ['forgetPassword', 'updateVisibleModal']),
      forgetPasswordUser: function () {
        this.rules = [];
        this.$refs.formF.resetValidation();
        this.data.language = this.language;
        this.forgetPassword({creds: this.data});
      },
      hideModal: function() {
        this.updateVisibleModal(false);
      }
    }
  }
</script>